<template>
    <button class="btn small filter" :class="{ active }">
      <span>{{ label }}</span><i v-if="active" class="icon-times" aria-label="remove"></i>
    </button>
</template>

<script>
  export default {
      name: 'SelectableButton',
      props: {
          label: {
            type: String,
            required: true,
          },
          active: {
            type: Boolean,
            required: false,
            default: false,
          },
      },
  };
</script>
